import { Theme, css } from '@emotion/react'
import {
  DesignToken,
  SpacingToken,
} from '@livechat/design-system-react-components'
import { ForwardedRef, ReactNode, forwardRef } from 'react'

import mediaQueries from '@/layout/media-queries'

const wrapperCss = css`
  font-size: 16px;
  margin-bottom: var(${SpacingToken.Spacing4});

  ${mediaQueries.mediumScreen()} {
    margin-bottom: var(${SpacingToken.Spacing11});
  }
`

const headerCss = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const actionCss = css`
  align-self: center;
`

const titleCss = ({ font }: Theme) => css`
  font-weight: ${font.bold};
  font-size: 18px;
  margin-bottom: var(${SpacingToken.Spacing2});
`

const dividerCss = css`
  display: block;
  width: 100%;
  height: 1px;
  background-color: var(${DesignToken.BorderBasicSecondary});
  margin: 0 auto var(${SpacingToken.Spacing5}) auto;
`

const anchorCss = css`
  display: block;
  height: 230px;
  margin-top: -230px;
  visibility: hidden;
`

interface Props {
  id: string
  title?: string | ReactNode
  action?: string | ReactNode
  hideDivider?: boolean
  innerRef?: ForwardedRef<HTMLElement>
  children: ReactNode
}

const Section = ({
  id,
  title,
  action,
  hideDivider,
  innerRef,
  children,
}: Props) => {
  const displayHeader = title || action

  return (
    <>
      <span css={anchorCss} id={id} />
      <section css={wrapperCss} ref={innerRef}>
        {!!displayHeader && (
          <>
            <div css={headerCss} data-test="section-title">
              {title && <h2 css={titleCss}>{title}</h2>}
              {action && <div css={actionCss}>{action}</div>}
            </div>

            {!hideDivider && <span css={dividerCss} />}
          </>
        )}

        {children}
      </section>
    </>
  )
}

export default forwardRef((props: Props, ref: ForwardedRef<HTMLElement>) => (
  <Section {...props} innerRef={ref} />
))
